/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[type=submit].btn[_ngcontent-%COMP%]{color:#ffff;background-color:#274c96;padding:1rem 1.5rem!important}input[type=submit][_ngcontent-%COMP%]:not(disabled).btn:not(){color:#274c96;background-color:#ffff;border:1px solid #274c96}\n/*# sourceMappingURL=activar-usuario.component.css.map*/"];
export { styles as styles };
